import { TransferOrderService } from './../../../../shared/services/transfer-order.service';
import { CommonService } from '../../../../shared/services/common.service';
import { AllotmentService } from '../../../services/allotment.service';
import { IKeyValuePair } from '../../../../_models/common/common';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transfer-order-export',
  templateUrl: './transfer-order-export.component.html',
  styleUrls: ['./transfer-order-export.component.css']
})
export class TransferOrderExportComponent implements OnInit {

  loading: boolean = false;
  designations: IKeyValuePair[];
  ids: number[] = [];

  constructor(
    private service: TransferOrderService,
    private commonService: CommonService) { }

  ngOnInit(): void {
    this.bindDropDown();
  }

  bindDropDown() {
    this.commonService.getDesignations().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.designations = response;
      }
    });
  }

  export() {
    this.loading = true;

    this.service.export(this.ids).subscribe(response => {
      if (response) {
        const blob = new Blob([response], { type: 'application/pdf' });
        var downloadURL = window.URL.createObjectURL(response);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "employee-list.pdf";
        link.click();
      }
    },
      (error) => console.log(error),
      () => this.loading = false);
  }



  changeDesignation(checked, item) {

    if (checked) {
      let id = this.ids ? this.ids.find(x => x == item) : null;
      if (!id)
        this.ids.push(item);
    }
    else {
      this.ids = this.ids.filter(x => x != item);
    }

  }

  isDesignationChecked(item) {
    var id = this.ids ? this.ids.find(x => x == item) : null;
    if (!id)
      return false;
    else
      return true;
  }

}
